import React from "react";
import ToolPrepCanvasMeta from "./ToolPrepCanvasMeta";

/**
 * Shared outer host for tool-prep image stages.
 * Owns the under-canvas dims/aspect footer so chrome stays one place.
 * Editor CanvasEditor stays separate; tool previews should wrap with this.
 */
const ToolPrepCanvasStage = React.forwardRef(
  (
    {
      className = "",
      children,
      metaImageUrl = null,
      metaWidth = null,
      metaHeight = null,
      showMeta = true,
      style,
      ...rest
    },
    ref
  ) => (
    <div className={className} ref={ref} style={style} {...rest}>
      {children}
      {showMeta ? (
        <ToolPrepCanvasMeta
          imageUrl={metaImageUrl}
          width={metaWidth}
          height={metaHeight}
        />
      ) : null}
    </div>
  )
);

ToolPrepCanvasStage.displayName = "ToolPrepCanvasStage";

export default ToolPrepCanvasStage;
